import { render, staticRenderFns } from "./BottomBtn.vue?vue&type=template&id=26126501"
import script from "./BottomBtn.vue?vue&type=script&lang=ts"
export * from "./BottomBtn.vue?vue&type=script&lang=ts"
import style0 from "./BottomBtn.vue?vue&type=style&index=0&id=26126501&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports